import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue"
  import { QSelect } from "quasar"
  
  import { EmploymentStatusOptions } from "src/const/select-options"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EmploymentStatusSelect',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return null
      }
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const employmentStatusRef = ref<QSelect | null>(null);
  function validate(){
    return employmentStatusRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QSelect), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      modelModifiers: { number: true },
      options: _unref(EmploymentStatusOptions),
      ref_key: "employmentStatusRef",
      ref: employmentStatusRef,
      rules: [val => (__props.required === true && !!val) || !__props.required || 'Required'],
      "emit-value": "",
      "popup-content-class": "text-body2 limit-dd-height",
      label: value.value ? undefined : 'Select a status...',
      "map-options": "",
      "data-cy": "employmentStatusSelect",
      outlined: "",
      dense: ""
    }, null, 8, ["modelValue", "options", "rules", "label"])
  ], 64))
}
}

})